export const SearchIcon = ({ className }: { className: string }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    fill='none'
    version='1.1'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    className={className}
  >
    <defs>
      <clipPath id='master_svg0_275_0325/53_6813'>
        <rect x='0' y='0' width='20' height='20' rx='0' />
      </clipPath>
    </defs>
    <g clipPath='url(#master_svg0_275_0325/53_6813)'>
      <g>
        <path
          d='M3.1494725,3.15337875Q0.8307295,5.4721287499999995,0.8307285,8.75129875Q0.8307295,12.03046875,3.1494725,14.34926875Q5.4682224999999995,16.66796875,8.7473925,16.66796875Q12.0265625,16.66796875,14.3453625,14.34926875Q16.6640625,12.03046875,16.6640625,8.75129875Q16.6640625,5.4721287499999995,14.3453625,3.15337875Q12.0265625,0.83463475,8.7473925,0.83463475Q5.4682224999999995,0.83463575,3.1494725,3.15337875ZM4.3279825,13.17066875Q2.4973955,11.34012875,2.4973955,8.75129875Q2.4973955,6.16247875,4.3279825,4.33188875Q6.1585725,2.50130175,8.7473925,2.50130175Q11.3362225,2.50130175,13.1667625,4.33188875Q14.9973625,6.16247875,14.9973625,8.75129875Q14.9973625,11.34012875,13.1667625,13.17066875Q11.3362225,15.00126875,8.7473925,15.00126875Q6.1585725,15.00126875,4.3279825,13.17066875Z'
          fillRule='evenodd'
          fill='#666666'
          fillOpacity='1'
        />
      </g>
      <g>
        <path
          d='M13.29178,14.470292Q13.15683,14.351404,13.08279,14.187502Q13.00875,14.023599,13.00875,13.84375Q13.00875,13.7615097,13.024794,13.68085Q13.040839,13.60019,13.072311,13.524209Q13.103783,13.448229,13.149473,13.379849Q13.195163,13.311469,13.253316,13.253316Q13.311469,13.195163,13.379849,13.149473Q13.448229,13.103783,13.524209,13.072311Q13.60019,13.040839,13.68085,13.024794Q13.7615097,13.00875,13.84375,13.00875Q14.0236,13.00875,14.187502,13.08279Q14.351404,13.15683,14.470292,13.29178L17.93126,16.75275Q18.066209999999998,16.87164,18.14025,17.03554Q18.21429,17.19944,18.21429,17.37929Q18.21429,17.46153,18.19825,17.54219Q18.1822,17.62285,18.15073,17.69883Q18.11926,17.77481,18.07357,17.84319Q18.02788,17.91157,17.96972,17.96973Q17.91157,18.02788,17.84319,18.07357Q17.77481,18.11926,17.69883,18.15073Q17.62285,18.1822,17.54219,18.19825Q17.46153,18.21429,17.37929,18.21429Q17.19944,18.21429,17.03554,18.14025Q16.87163,18.066209999999998,16.75275,17.93126L13.29178,14.470292Z'
          fillRule='evenodd'
          fill='#666666'
          fillOpacity='1'
        />
      </g>
    </g>
  </svg>
)
